import React, { useEffect, useState } from "react";
import MedicalService from "../../Services/MedicalService";
import dayjs from "dayjs";
import { HSdecrypt } from "../../utils/encryptPassword";
import { data } from "autoprefixer";

function AllergyDetails(props) {
  const [patientAlleryData, setPatientAlleryData] = useState([]);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  useEffect(() => {
    PatientAllergies();
  }, [props.selectedPatient]);

  const PatientAllergies = () => {
    let payload = {
      patientCode: props.selectedPatient,
      status: 1,
    };
    MedicalService.HSPatientAllergyList(payload)
      .then((result) => {
        const decryptedData = HSdecrypt(result.data.data);
        setPatientAlleryData(JSON.parse(decryptedData));
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <>
      <div
        className="bg-white rounded-xl border border-gray-200 shadow-sm w-full"
        id="unquie-scroll"
      >
        <div className="flex justify-between items-center p-3">
          <h3 className="text-sm font-bold text-gray-700">Allergy Details</h3>
          <div className="flex items-center gap-2 text-blue-500 font-sans font-medium underline text-xs cursor-pointer">
            {/* <HiPlusCircle className="text-primaryColor w-7 h-7"/> */}
          </div>
        </div>
        <hr />
        <div className="h-60 p-3 overflow-y-scroll flex flex-col gap-3 scrollWidth">
          {patientAlleryData.length > 0 ? (
            patientAlleryData.map((user, i) => (
              <div
                className="relative"
                onMouseEnter={() => setHoveredIndex(i)}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                <div className="overflow-y-scroll pr-2 scrollWidth flex flex-col gap-2">
                  <div className="bg-[#F7FFFE] border border-[#95F0DF] border-l-4 rounded-lg p-3 text-xs text-gray-700 flex flex-col gap-2">
                    <p>
                      <strong>Drug Allergies:</strong> {user.drugAllergy}
                    </p>
                    <p>
                      Onset Date : {dayjs(user.givenDate).format("YYYY-MM-DD")}
                    </p>
                  </div>
                </div>
                {hoveredIndex === i && (
                  <div
                    className="fixed bg-[#585858] text-white text-xs rounded-lg shadow-lg p-3 z-50"
                    style={{ top: "200px", left: "300px" }}
                  >
                    {" "}
                    {user.drugAllergy && (
                      <p>
                        <strong>Drug Allergies:</strong> {user.drugAllergy}
                      </p>
                    )}
                    {user.foodAllergy && (
                      <p>
                        <strong>Food Allergies:</strong> {user.foodAllergy}
                      </p>
                    )}
                    {user.chemicalAllergy && (
                      <p>
                        <strong>Chemical Allergies:</strong>{" "}
                        {user.chemicalAllergy}
                      </p>
                    )}
                    {user.otherAllergy && (
                      <p>
                        <strong>Other Allergies:</strong> {user.otherAllergy}
                      </p>
                    )}
                    <p>
                      <strong>Onset date:</strong>{" "}
                      {dayjs(user.givenDate).format("YYYY-MM-DD")}
                    </p>
                  </div>
                )}
              </div>
            ))
          ) : (
            <div></div>
          )}
        </div>
      </div>
      {/* <div className=" w-full max-w-[370px] h-[300px] sm:h-[340px] md:h-[370px] md:m-5 border rounded-lg">
        <div className="h-[13%] bg-secondaryColor flex items-center justify-center rounded p-2">
          <h1 className="font-bold text-normal text-white mt-3">
            Allergy Details
          </h1>
        </div>
        <div className="h-[75%] overflow-y-scroll scrollwidth items-center bg-white border-t-2">
          {
            patientAlleryData.length > 0 ?
              patientAlleryData.map((user, i) => (
                <div key={i} className="border rounded-md m-3 p-2">
                  <div className="text-sm">
                    <p className="font-medium mx-3">
                      Drug Allergies:
                      <span className="font-semibold text-gray-500">
                        {" "}
                        {user.drugAllergy}
                      </span>
                    </p>
                  </div>
                  <div className="text-sm">
                    <p className="font-medium mx-3">
                      Food Allergies:
                      <span className="font-semibold text-gray-500">
                      {user.foodAllergy}{" "}
                      </span>
                    </p>
                  </div>
                  <div className="text-sm">
                    <p className="font-medium mx-3">
                      Chemical Allergies:
                      <span className="font-semibold text-gray-500">
                        {" "}
                        {user.chemicalAllergy}
                      </span>
                    </p>
                  </div>
                  <div className="text-sm">
                    <p className="font-medium mx-3">
                      Other Allergies:
                      <span className="font-semibold text-gray-500">
                        {" "}
                        {user.otherAllergy}
                      </span>
                    </p>
                  </div>
                  <div className="">
                    <div className="font-semibold text-gray-500 text-sm mt-2">
                      Onset date: <span className="font-semibold text-gray-500">{dayjs(user.givenDate).format('YYYY-MM-DD')}</span>
                    </div>
                  </div>
                </div>
              ))
            : null
          }
        </div>
        <div className="footer h-[44px] bg-secondaryColor rounded"></div>
      </div> */}
    </>
  );
}

export default AllergyDetails;
